import { render, staticRenderFns } from "./DropZones.vue?vue&type=template&id=bcc36c4c&"
import script from "./DropZones.vue?vue&type=script&lang=js&"
export * from "./DropZones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports